module.exports = __webpack_public_path__ + "img/ckblogo.6402fb1e.png";